export const INVENTORY = 'inventory';
export const CATALOG = 'catalog';

export default {
    INVENTORY,
    CATALOG,
};



// WEBPACK FOOTER //
// ./src/constants/vehicleTypes.js